const defaultSearches = [
  {
    countryId: 'pl',
    keyword: 'narty',
    category: 'wintersports',
    subcategory: 'wintersports_alpineskiing',
    exact: true,
  },
  {
    countryId: 'pl',
    keyword: 'snowboard',
    category: 'wintersports',
    subcategory: 'wintersports_snowboard',
    exact: true,
  },
  {
    countryId: 'pl',
    keyword: 'raki',
    category: 'tourism',
    subcategory: 'tourism_crampons',
    exact: false,
  },
  {
    countryId: 'pl',
    keyword: 'trena',
    category: 'bikes',
    subcategory: 'bikes_treadmill',
    exact: true,
  },
  {
    countryId: 'pl',
    keyword: 'nosidełko',
    category: 'tourism',
    subcategory: 'tourism_carrier',
    exact: true,
  },
  {
    countryId: 'hu',
    keyword: 'elektromos kerékpárok',
    category: 'bikes',
    subcategory: 'bikes_electric',
    exact: true,
  },
  {
    countryId: 'hu',
    keyword: 'kemping sátrak',
    category: 'camping',
    subcategory: 'camping_tent',
    exact: true,
  },
  {
    countryId: 'hu',
    keyword: 'mountain bikes',
    category: 'bikes',
    subcategory: 'bikes_mountain',
    exact: true,
  },
  {
    countryId: 'hu',
    keyword: 'országúti kerékpárok',
    category: 'bikes',
    subcategory: 'bikes_road',
    exact: true,
  },
  {
    countryId: 'hu',
    keyword: 'SUP',
    category: 'watersports',
    subcategory: 'watersports_sup',
    exact: true,
  },
  {
    countryId: 'cz',
    keyword: 'stan',
    category: 'camping',
    subcategory: 'camping_tent',
    exact: true,
  },
  {
    countryId: 'cz',
    keyword: 'Stand Up Paddleboardy',
    category: 'watersports',
    subcategory: 'watersports_sup',
    exact: true,
  },
  {
    countryId: 'cz',
    keyword: 'elektrokolo',
    category: 'bikes',
    subcategory: 'bikes_electric',
    exact: true,
  },
  {
    countryId: 'cz',
    keyword: 'gravel kolo',
    category: 'bikes',
    subcategory: 'bikes_gravel',
    exact: true,
  },
  {
    countryId: 'cz',
    keyword: 'horské kolo',
    category: 'bikes',
    subcategory: 'bikes_mountain',
    exact: true,
  },
  {
    countryId: 'cz',
    keyword: 'horské elektrokolo',
    category: 'bikes',
    subcategory: 'bikes_electric',
    exact: false,
  },
  //   {
  //   countryId: 'cz',
  //   keyword: 'lyže',
  //   category: 'wintersports',
  //   subcategory: 'wintersports_alpineskiing',
  //   exact: true,
  // },
  // {
  //   countryId: 'cz',
  //   keyword: 'běžky',
  //   category: 'wintersports',
  //   subcategory: 'wintersports_crosscountry',
  //   exact: true,
  // },
  // {
  //   countryId: 'cz',
  //   keyword: 'snowboard',
  //   category: 'wintersports',
  //   subcategory: 'wintersports_snowboard',
  //   exact: true,
  // },
  // {
  //   countryId: 'cz',
  //   keyword: 'lední brusle',
  //   category: 'wintersports',
  //   subcategory: 'wintersports_other',
  //   exact: true,
  // },
  // {
  //   countryId: 'cz',
  //   keyword: 'sněžnice',
  //   category: 'tourism',
  //   subcategory: 'tourism_snowshoes',
  //   exact: true,
  // },
  // {
  //   countryId: 'cz',
  //   keyword: 'snowboardové boty',
  //   category: 'wintersports',
  //   subcategory: 'wintersports_snowboard',
  //   exact: false,
  // },
  // {
  //   countryId: 'cz',
  //   keyword: 'běžecký pás',
  //   category: 'fitness',
  //   subcategory: 'fitness_cardio',
  //   exact: false,
  // },
  // lt
];

export default defaultSearches;
